import { getDb, loadFirestoreModule } from "@/lib/firebase/db";
import { getArticle, getProducts } from "@/lib/catalog";
import type { Order, OrderItem } from "@/types";

/** Best-effort productafbeelding voor een order-regel (uit de gebundelde catalogus). */
export function orderItemImage(item: OrderItem): string | undefined {
  if (item.type === "article") return getArticle(item.productId)?.image;
  const vId = item.variantId ?? item.productId; // glas: productId == variantId
  for (const p of getProducts()) {
    const v = p.variants?.find((x) => x.id === vId);
    if (v) return v.imageUrl ?? p.variants?.find((x) => x.imageUrl)?.imageUrl;
  }
  return undefined;
}

/**
 * De eigen bestellingen van een ingelogde klant (orders met customerUid == uid).
 * Client-side gesorteerd op datum, zodat er geen samengestelde Firestore-index nodig is.
 * Werkt alleen op het live domein (App Check blokkeert Firestore op localhost).
 */
export async function getMyOrders(uid: string): Promise<Order[]> {
  const [{ collection, getDocs, query, where }, db] = await Promise.all([loadFirestoreModule(), getDb()]);
  const snap = await getDocs(query(collection(db, "orders"), where("customerUid", "==", uid)));
  const orders = snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<Order, "id">) }));
  return orders.sort((a, b) => (b.createdAt ?? 0) - (a.createdAt ?? 0));
}
